import { Component } from '@angular/core';
import { NavController, NavParams,App,AlertController} from 'ionic-angular';
import {AppState} from '../../../app/app.global';
import {ServiceeditPage} from '../serviceedit/serviceedit';
import {SearchPage} from '../../commonsearch/search/search';
import {XxtxmsglistPage} from '../../message/xxtxmsglist/xxtxmsglist';
import { LoginPage } from '../../login/login/login';

import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { THIRD_APP_JUMP, SERVICE_SELECT_MYCOLLECT,SERVICE_SELECT_MYALL_APPTYPES} from '../../../providers/config/serviceurl';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
/**
 * 服务页面
 */
@Component({
  selector: 'page-servicehome',
  templateUrl: 'servicehome.html',
})
export class ServicehomePage {

  user:any={};
  resourceUrl = "";//资源服务器ip和端口号

  myserviceImgList:any=[];
  serviceList:any = [];

  constructor(public navCtrl: NavController, public appCtrl:App,public navParams: NavParams,
          public global:AppState,private httpService:HttpService,private alertCtrl: AlertController,
          private inAppBrowser:InAppBrowser) {
    this.user = StorageService.getObj('currentUser');
    this.resourceUrl = StorageService.getObj('resourceUrl') + "/";
    if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
			this.appCtrl.getRootNav().push(LoginPage);
		}
  }

   //当将要进入页面时触发
  ionViewWillEnter(){
    if(this.user!=null&&this.user!=""&&this.user.userId!=null&&this.user.userId!='undefined'&&this.user.userId!=''){
      this.dataInit();
		}
  }
  dataInit() {
    this.reset();
    this.loadMyserviceList();
    this.loadServiceList();
  }

  //置空数据
  reset(){
    this.myserviceImgList = [];
    this.serviceList = [];
  }

  gotoServe(event:any, item:any){
    let colorTheme = this.global.colorTheme;
      if(colorTheme != null && colorTheme != undefined && colorTheme.length > 4){
        colorTheme = '#' + colorTheme.substring(5,colorTheme.length);
    }
    console.dir(item);
    if(item != null && item != undefined){
      let o = item.SERVICE_APP_SUBSERVICE;
      if(o != null && o != undefined && o !=''){
         let title = o[0].SUBSERVICE_NAME;
         let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
         let flag = "thirdApp";
         let flag2 = "innerUser";
         if(url.indexOf(flag) != -1){
         
          this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_blank','location=yes');
         }
         else if(url.indexOf(flag2) != -1){
          this.httpService.openOuterLink(title, url,colorTheme);
         }else{
        this.inAppBrowser.create(url,'_blank','location=yes');
         }
  
      }
      }
  }
  
  urlencode (str) {  
      str = (str + '').toString();   
      return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
      replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
  } 
  

  //加载我的服务列表
  loadMyserviceList(){
    let params = {'username':this.user.xgh,'pageNo':0,'pageSize':5,'loadAll':false};
    this.httpService.get2(SERVICE_SELECT_MYCOLLECT,params).then(anyObj =>this.handleLoadMyserviceList(anyObj));
  }
  handleLoadMyserviceList(obj:any){
    if(obj != null && obj != undefined){
      this.myserviceImgList = obj.items;
    }
  }
  
  //加载服务列表
  loadServiceList(){
    let params = {'username':this.user.xgh};
    this.httpService.get2(SERVICE_SELECT_MYALL_APPTYPES,params).then(anyObj =>this.handleloadServiceList(anyObj));
  }
  handleloadServiceList(obj:any){
    if(obj != null && obj != undefined){
      this.serviceList = obj.items;
      console.log(this.serviceList);
    }
  }

  serviceEditCallback = (params)=>{
		return new Promise((resolve, reject) => {
      if(typeof(params)!='undefined'){
          resolve('ok');
          this.sleep(300);
          this.dataInit();
      }else{
          reject(Error('error'))
      }
   });
  }
  
  sleep(numberMillis) {
    var now = new Date();
    var exitTime = now.getTime() + numberMillis;
    while (true) {
       now = new Date();
       if (now.getTime() > exitTime)
       　　return;
       }
    }


  //跳转到编辑服务页面
  gotoEditServicePage(){
    this.appCtrl.getRootNav().push(ServiceeditPage,{"serviceList":this.serviceList,callback: this.serviceEditCallback});
  }


  //跳转到搜索页面
  gotoSerchHome(){
    this.appCtrl.getRootNav().push(SearchPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/service/servicehome/servicehome.ts